module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("开通会员，保障求职效果！若开始找工作（有投递、权益使用、微聊沟通等行为，具体以会员协议中要求为准）后30天之内收不到面试邀请，你将获得高额赔偿！")])]), _vm._v(" "), _c('div', {
    staticClass: "qzbz-bg"
  }, [_c('p', {
    staticClass: "des-title"
  }, [_vm._v("— 理赔说明 —")]), _vm._v(" "), _c('p', {
    staticClass: "des-text"
  }, [_vm._v("不同市场会员赔付金额如下（全额赔付）：")]), _vm._v(" "), _c('ul', {
    staticClass: "items"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "des-time"
  }, [_vm._v("会员套餐")]), _vm._v(" "), _c('div', {
    staticClass: "desc price"
  }, [_vm._v("价格")]), _vm._v(" "), _c('div', {
    staticClass: "desc money"
  }, [_vm._v("赔付价格")])]), _vm._v(" "), _vm._l((_vm.compensateData), function(item, index) {
    return _c('li', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "des-time"
    }, [_vm._v(_vm._s(item['time']))]), _vm._v(" "), _c('div', {
      staticClass: "desc money"
    }, [_vm._v(_vm._s(item['price']))]), _vm._v(" "), _c('div', {
      staticClass: "desc money"
    }, [_vm._v(_vm._s(item['money']))])])
  })], 2)])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.vipState === 3 ? '仅新版会员可享受' : _vm.vipState === 2 ? '已申请赔付' : _vm.btnTxt2
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "applyCompensate": function($event) {
        return _vm.applyCompensate()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("求职保障")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("苦苦等不到面试和电话？若开始找工作（有投递、权益使用、微聊沟通等行为，具体以会员协议中要求为准）后30天之内收不到面试邀请，你将获得高额赔偿！")])]), _vm._v(" "), _c('div', {
    staticClass: "qzbz-bg"
  }, [_c('p', {
    staticClass: "des-title"
  }, [_vm._v("— 理赔说明 —")]), _vm._v(" "), _c('p', {
    staticClass: "des-text"
  }, [_vm._v("不同市场会员赔付金额如下（全额赔付）：")]), _vm._v(" "), _c('ul', {
    staticClass: "items"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "des-time"
  }, [_vm._v("会员套餐")]), _vm._v(" "), _c('div', {
    staticClass: "desc price"
  }, [_vm._v("价格")]), _vm._v(" "), _c('div', {
    staticClass: "desc money"
  }, [_vm._v("赔付价格")])]), _vm._v(" "), _vm._l((_vm.compensateData), function(item, index) {
    return _c('li', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "des-time"
    }, [_vm._v(_vm._s(item['time']))]), _vm._v(" "), _c('div', {
      staticClass: "desc price"
    }, [_vm._v(_vm._s(item['price']))]), _vm._v(" "), _c('div', {
      staticClass: "desc money"
    }, [_vm._v(_vm._s(item['money']))])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc165a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/QzbzDialog.vue
// module id = cUUQ
// module chunks = 1